import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TopbarService {
    private readonly inquiryButtonVisibleState = signal(false);

    readonly inquiryButtonVisible = this.inquiryButtonVisibleState.asReadonly();

    public setInquiryButtonVisible(visible: boolean): void {
        this.inquiryButtonVisibleState.set(visible);
    }
}
